import Vue from 'vue'
// import Qs from 'qs'

// api公共路径
export const baseUrl = process.env.VUE_APP_BASE_URL

// 新闻相关api地址
export const newsUrl = process.env.VUE_APP_NEWS_URL

// get 请求
export function httpGet ({ url, params = {} }) {
  return new Promise((resolve, reject) => {
    Vue.axios({
      url,
      method: 'get',
      params
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}
// post请求
export function httpPost ({ url, data = {}, params = {}, headers = {} }) {
  return new Promise((resolve, reject) => {
    Vue.axios({
      url,
      method: 'post',
      // 发送的数据, 如果需要formData格式数据使用Qs.stringify转换一下
      data,
      // url参数
      params,
      headers
    }).then(res => {
      resolve(res.data)
    })
  })
}
